import { Stack } from '@mantine/core';
import { IJobStatsList } from '@th-types/jobs.type';
import IJobDetail, { JobMember } from '@th-types/job.detail.type';
import { emptyJobStats } from '@utils/JobUtils';
import JobTableItemMobile from './JobTableItemMobile';

interface Props {
  jobList: IJobDetail[];
  jobStatsList: IJobStatsList;
  hideJob: (job: IJobDetail) => void;
  showJobMembers: (members: JobMember[]) => void;
  handleOpenModalShareJobLink: (job: IJobDetail) => void;
}

export default function JobTableMobile({
  jobList,
  jobStatsList,
  hideJob,
  showJobMembers,
  handleOpenModalShareJobLink,
}: Props) {
  return (
    <Stack gap={8}>
      {jobList.map((job) => {
        const jobStats =
          jobStatsList.results.find((jobItem) => jobItem.jobId === job.id) ??
          emptyJobStats(job.id);

        return (
          <JobTableItemMobile
            key={job.id}
            job={job}
            jobStats={jobStats}
            hideJob={hideJob}
            showJobMembers={showJobMembers}
            handleOpenModalShareJobLink={handleOpenModalShareJobLink}
          />
        );
      })}
    </Stack>
  );
}
